import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { TreatabilityInsight } from '@/pages/Treatability/types';
import RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import logAjaxError from '@/utils/logAjaxError';

export const treatabilityRepository = {
  async getTreatabilityData({
    host,
    personId
  }: {
    host: string;
    personId: string;
  }): Promise<RepositoryResponse<TreatabilityInsight>> {
    try {
      const path = `/api/dugout/treatability-insight/${personId}/`;
      const response = await ajax.get({
        url: `${host}${path}`
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);

      return {
        errorMessage: `Failed to get treatability data: ${(error as AxiosError).message}`,
        error: error as AxiosError,
        isError: true
      };
    }
  }
};

const TreatabilityRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getTreatabilityData(personId: string): Promise<RepositoryResponse<TreatabilityInsight>> {
      return treatabilityRepository.getTreatabilityData({ host, personId });
    }
  };
};

export default TreatabilityRepository;
